<template>
  <div class="page-not-found text-center">
    <div class="face">
      <div class="band">
        <div class="red"></div>
        <div class="white"></div>
        <div class="blue"></div>
      </div>
      <div class="eyes"></div>
      <div class="dimples"></div>
      <div class="mouth"></div>
    </div>
    <h1>404</h1>
    <h2>{{$t('page_not_found')}}</h2>
    <localized-link to="" class="btn-rounded btn btn-info btn-md ripple-parent">{{$t('return_to_home')}}</localized-link>
  </div>
</template>

<script>
import LocalizedLink from '@/components/Menu'

export default {
  name: "PageNotFound",
  components: { LocalizedLink }
}
</script>

<style scoped>
*, *:before, *:after {
box-sizing: content-box;
-webkit-transform: translate3d(0, 0, 0);
transform: translate3d(0, 0, 0);
}
.face {
width: 300px;
height: 300px;
border: 4px solid #383A41;
border-radius: 10px;
background-color: #F2EEE8;
margin: 0 auto;
margin-top: 100px;
}
.face .band {
width: 350px;
height: 27px;
border: 4px solid #383A41;
border-radius: 5px;
margin-left: -25px;
margin-top: 50px;
}
.face .band .red {
height: calc(100% / 3);
width: 100%;
background-color: #EB6D6D;
}
.face .band .white {
height: calc(100% / 3);
width: 100%;
background-color: #FFFFFF;
}
.face .band .blue {
height: calc(100% / 3);
width: 100%;
background-color: #5E7FDC;
}
.face .band:before {
content: "";
display: inline-block;
height: 27px;
width: 30px;
background-color: rgba(255, 255, 255, 0.3);
position: absolute;
z-index: 999;
left: 0;
}
.face .band:after {
content: "";
display: inline-block;
height: 27px;
width: 30px;
background-color: rgba(56, 58, 65, 0.3);
position: absolute;
z-index: 999;
right: 0;
margin-top: -27px;
}
.face .eyes {
width: 128px;
margin: 0 auto;
margin-top: 40px;
}
.face .eyes:before {
content: "";
display: inline-block;
width: 30px;
height: 15px;
border: 7px solid #383A41;
margin-right: 20px;
border-top-left-radius: 22px;
border-top-right-radius: 22px;
border-bottom: 0;
}
.face .eyes:after {
content: "";
display: inline-block;
width: 30px;
height: 15px;
border: 7px solid #383A41;
margin-left: 20px;
border-top-left-radius: 22px;
border-top-right-radius: 22px;
border-bottom: 0;
}
.face .dimples {
width: 180px;
margin: 0 auto;
margin-top: 15px;
}
.face .dimples:before {
content: "";
display: inline-block;
width: 10px;
height: 10px;
margin-right: 80px;
border-radius: 50%;
background-color: rgba(235, 109, 109, 0.4);
}
.face .dimples:after {
content: "";
display: inline-block;
width: 10px;
height: 10px;
margin-left: 80px;
border-radius: 50%;
background-color: rgba(235, 109, 109, 0.4);
}
.face .mouth {
width: 40px;
height: 5px;
border-radius: 5px;
background-color: #383A41;
margin: 0 auto;
margin-top: 25px;
}
.page-not-found h1 {
font-size: 10em;
font-weight: 800;
}
.page-not-found h2 {
font-weight: 800;
color: #383A41;
text-align: center;
font-size: 2.5em;
text-transform: uppercase;
}
.page-not-found .btn {
margin-top: 50px;
}
@media screen and (max-width: 400px) {
.page-not-found .btn {
margin-top: 30px;
margin-bottom: 50px;
}
.page-not-found .face {
margin-top: 40px;
-webkit-transform: scale(0.8);
transform: scale(0.8);
}
.page-not-found h2 {
padding-top: 20px;
padding-left: 20px;
padding-right: 20px;
font-size: 2em;
}
}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue